/* eslint-disable max-len */
import {
  LANDING_PAGE_COVER_GET_URL,
  LANDING_PAGE_COVER_SET_ACTIVE_URL,
  LANDING_PAGE_COVER_UPLOAD_URL,
} from '@1po/1po-bff-fe-spec/generated/backoffice/BackofficeURLs';
import { SetLandingPageCoverActiveRequest } from '@1po/1po-bff-fe-spec/generated/backoffice/landing_page_cover/request/SetLandingPageCoverActiveRequest';
import { UploadLandingPageCoverRequest } from '@1po/1po-bff-fe-spec/generated/backoffice/landing_page_cover/request/UploadLandingPageCoverRequest';
import {
  BACKOFFICE_LANDING_PAGE_COVER_GET_RESPONSE,
  BACKOFFICE_LANDING_PAGE_COVER_SET_ACTIVE_RESPONSE,
} from '@1po/1po-bff-fe-spec/generated/common/ResponseType';
import { RequestResponseMappingManager } from 'domains/webSockets/WebSocket.requestsResponseMapping';
import { WebSocketAction } from 'utils';
import { wsSendAction } from 'utils/domainStore/api';

// Register request-response mappings
RequestResponseMappingManager.addMapping(LANDING_PAGE_COVER_GET_URL, BACKOFFICE_LANDING_PAGE_COVER_GET_RESPONSE);
RequestResponseMappingManager.addMapping(
  LANDING_PAGE_COVER_UPLOAD_URL,
  BACKOFFICE_LANDING_PAGE_COVER_SET_ACTIVE_RESPONSE,
);
RequestResponseMappingManager.addMapping(
  LANDING_PAGE_COVER_SET_ACTIVE_URL,
  BACKOFFICE_LANDING_PAGE_COVER_SET_ACTIVE_RESPONSE,
);

export function sendGetLandingPageCoversRequest(): WebSocketAction {
  return wsSendAction(LANDING_PAGE_COVER_GET_URL, {});
}

export function sendUploadLandingPageCoverRequest(request: UploadLandingPageCoverRequest): WebSocketAction {
  return wsSendAction(LANDING_PAGE_COVER_UPLOAD_URL, request);
}

export function sendSetLandingPageCoverActiveRequest(request: SetLandingPageCoverActiveRequest): WebSocketAction {
  return wsSendAction(LANDING_PAGE_COVER_SET_ACTIVE_URL, request);
}
